import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect} from 'react';
import {ParagraphNode} from 'lexical';
import {
    setDefaultParagraphStyles,
    StyledParagraphNode
} from '../nodes/StyledParagrah';

export function ParagraphReplacementPlugin(): null {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        // Register node transforms to replace paragraph nodes
        const removeTransform = editor.registerNodeTransform(ParagraphNode, (node: ParagraphNode) => {
            // Only transform if it's not already a StyledParagraphNode
            if (!(node instanceof StyledParagraphNode)) {
                const styledNode = setDefaultParagraphStyles(node);
                // Replace the node
                node.replace(styledNode);

                // Move all children to the new node
                const children = node.getChildren();
                children.forEach(child => styledNode.append(child));
            }
        });

        return removeTransform;
    }, [editor]);

    return null;
}
